import strings from '../strings';
import * as no from '../assets/testAnswers/no';
import * as nn from '../assets/testAnswers/nn';
import * as de from '../assets/testAnswers/de';
import * as se from '../assets/testAnswers/se';
import NonwordRepetition from 'tests/NonwordRepetition';

export const getTestLanguage = () => {
	switch (strings.getLanguage()) {
		case 'no':
			return no;
		case 'nn':
			return nn;
		case 'de':
			return de;
		case 'se':
			return se;
		default:
			return se;
	}
};

export const getWorkingMemory = () => ({
	stages: [
		'Intro',
		'Trial',
		'Pause',
		'numbers',
		'Pause',
		'Intro',
		'words',
		'Pause',
	],
	getNumberSteps: () => {
		return getTestLanguage().WMNAnswers;
	},
	getWordSteps: () => {
		return getTestLanguage().WMWAnswers;
	},
	getIntroSteps: () => {
		return [];
	},
	getNumberTrialSteps: () => {
		return getTestLanguage().WMNTrialAnswers;
	},
	getWordTrialSteps: () => {
		return getTestLanguage().WMWTrialAnswers;
	},
});

export const getSetningsMinne = (testKeyType, ageGroup) => ({
	stages: ['Intro', 'Trial', 'Pause', 'Test', 'Pause'],
	getIntroSteps: () => {
		return [];
	},

	getTrialSteps: (tk = testKeyType, ag = ageGroup) => {
		const lang = getTestLanguage();
		if (!lang) return [];

		if (tk === 'adult-followup') {
			return lang.SM_adult_trialSentences || [];
		}

	/* 	if (tk === 'youth-followup') {
			return lang.SM_youth_trialSentences || [];
		}
		if (tk === 'child-followup' && (ag === 5 || ag === 6 || ag === 7)) {
			return lang.SM_trialSentencesUpper || [];
		} */

		// child behaviour
		return lang.SM_adult_trialSentences || [];
	},

	getSentenceSteps: (tk = testKeyType, ag = ageGroup) => {
		const lang = getTestLanguage();
		if (!lang) return [];

		if (tk === 'adult-followup') {
			return lang.SM_adult_testSentences || [];
		}

		/* if (tk === 'youth-followup') {
			return lang.SM_youth_testSentences || [];
		}
		if (tk === 'child-followup' && (ag === 5 || ag === 6 || ag === 7)) {
			return lang.SM_testSentencesUpper || [];
		} */
		// child behaviour
		return lang.SM_adult_testSentences || [];
	},
});

export const getNonwordRepetition = (testKeyType, ageGroup) => ({
  // Same five-stage structure as SentenceMemory
  stages: ['Intro', 'Trial', 'Pause', 'Test', 'Pause'],

  getIntroSteps: () => {
    // Intro has no discrete steps; runner advances on nextStep()
    return [];
  },

  getTrialSteps: (tk = testKeyType, ag = ageGroup) => {
     const lang = getTestLanguage();
    if (!lang) return [];

    if (tk === 'adult-followup') {
      return lang.nonword_adult_trialWords || [];
    }

   /*  if (tk === 'youth-followup') {
      return lang.nonword_youth_trialWords || [];
    }*/
    // For now: only child-followup uses this test
    return lang.nonword_adult_trialWords || []; 
  },

  getNonwordSteps: (tk = testKeyType, ag = ageGroup) => {
   const lang = getTestLanguage();
    if (!lang) return [];

    if (tk === 'adult-followup') {
      return lang.nonword_adult_testWords || [];
    }

   /*  if (tk === 'youth-followup') {
      return lang.nonword_youth_testWords || [];
    }*/
    return lang.nonword_adult_testWords || []; 
  },
});


export const getSpoonerism = () => ({
	stages: ['Intro', 'Test', 'Pause'],
	getSteps: () => {
		return getTestLanguage().SpoonerismAnswers;
	},
	getIntroSteps: () => {
		return ['intro', ...getTestLanguage().SpoonerismIntroTasks, 'summary'];
	},
});

export const getRapidNaming = (ageGroup) => ({
	stages: ['Intro', 'Test', 'Pause'],
	getSteps: () => {
		 return [].concat(...getTestLanguage().rnAnswers);
	},
	getAnswers: () => {
		let testItems = [];
			testItems = JSON.parse(JSON.stringify(getTestLanguage().rnAnswers));
		return testItems;
	},
	getIntroSteps: () => {
		return getTestLanguage().rnIntroSteps;
	},
});

export const getPhonemeIsolation = (testKeyType, ageGroup) => ({
	stages: ['Intro', 'Test', 'Pause'],
	getSteps: () => {
		return getTestLanguage().phonemeIsolationNormingTasks;
	},
	getIntroSteps: () => {
		return getTestLanguage().phonemeIsolationIntro;
	},
});

export const getOneMinute = () => ({
	stages: ['Intro', 'Test', 'Pause'],
	getSteps: () => {
		return getTestLanguage().oneMinuteTasks;
	},
	getIntroSteps: () => {
		return [];
	},
});

export const getLetterKnowledge = (testKeyType, ageGroup) => ({
	stages: ['Intro', 'Test', 'Pause'],
	getSteps: () => {
		return testKeyType === 'youth-followup' ||
			testKeyType === 'adult-followup'
			? getTestLanguage().lkAnswersNorming
			: ageGroup === 0 || ageGroup === 1
			? getTestLanguage().kdlkAnswers
			: getTestLanguage().lkAnswers;
	},
	getIntroSteps: () => {
		return [];
	},
});

export const getPhonemeDeletion = () => ({
	stages: ['Intro', 'Test', 'Pause'],
	getSteps: () => {
		return getTestLanguage().pdSteps.slice();
	},
	getAnswers: () => {
		return getTestLanguage().pdAnswers;
	},
	getIntroSteps: () => {
		return ['intro', ...getTestLanguage().pdIntroSteps, 'outro'];
	},
});

export const getWordDictation = (testKeyType) => ({
	//Word Dictation
	stages: ['Intro', 'Test', 'Pause'],
	getSteps: () => {
		return testKeyType === 'youth-followup' ||
			testKeyType === 'adult-followup'
			? getTestLanguage().wdAnswersNorming.slice()
			: getTestLanguage().wdAnswers.slice();
	},
	getIntroSteps: () => {
		return [];
	},
});

export const tests = {
	LetterKnowledge: getLetterKnowledge,
	WorkingMemory: getWorkingMemory,
	RapidNaming: getRapidNaming,
	PhonemeIsolation: getPhonemeIsolation,
	PhonemeDeletion: getPhonemeDeletion,
	OneMinute: getOneMinute,
	WordDictation: getWordDictation,
	Spoonerism: getSpoonerism,
	SentenceMemory: getSetningsMinne,
	NonwordRepetition:getNonwordRepetition,
};
export default tests;
